import { gql } from 'urql';

const UPDATE_OPPORTUNITY = gql`
  mutation UpdateOpportunity(
    $_set: opportunities_set_input!
    $id: Int!
    $activity: String
    $timestamp: bigint
    $userId: Int
  ) {
    update_opportunities_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
    }

    insert_opportunities_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default UPDATE_OPPORTUNITY;
